const PRIVILEGED_ROLES = new Set(['admin', 'manager', 'partner', 'institution']);

export const isPrivilegedUser = (user) => {
  if (!user) return false;

  return Boolean(
    user.is_staff ||
    user.is_superuser ||
    PRIVILEGED_ROLES.has(user.role)
  );
};

export const canAccessAnalytics = isPrivilegedUser;
